import React, { useState } from "react";
import './ViewProjectContacts.css';
import ViewProjectContractor from "./ViewProjectContractor/ViewProjectContractor";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import ViewProjectEngineer from "./ViewProjectEngineer/ViewProjectEngineer";
import ViewProjectArchitect from "./ViewProjectArchitect/ViewProjectArchitect";
import ViewProjectTabs from "../ViewProjectTabs/ViewProjectTabs";

export default function ViewProjectContacts(){

    const [showContacts, setShowContacts] = useState(false);

    const tabs = [
        { key: "contractor", label: "Contractor", component: <ViewProjectContractor /> },
        { key: "engineer", label: "Engineering", component: <ViewProjectEngineer /> },
        { key: "tasks", label: "Architecture", component: <ViewProjectArchitect /> },
       
    ];

    return(
        <div>
            <div className="project-section-header">
                <h5 className="section-title mobile-only">Contacts</h5>
                <div className="project-header-actions">
                    {/* Buttons? */}
                    {' '}
                </div>
            </div>

            <ViewProjectTabs tabs={tabs} />

           
        </div>
    )
}